import {omit} from "@pg-mono/nodash";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {IOfferDetailPropertiesResponse} from "../../offer/detail/actions/fetch_offer_detail_properties";
import {IFetchParams} from "../utils/get_property_api_params";

export const fetchAllPropertiesCount = (params: IFetchParams, disablePriceFiltering: boolean = false) => {
    const url = appendQueryString(apiV2Link.property.configurator(Scenario.PROPERTY_CONFIGURATOR_LIST), {
        ...(disablePriceFiltering ? omit({...params}, ["price_0", "price_1"]) : params),
        page_size: 0
    });

    return getRequest({}, url).then((json: IOfferDetailPropertiesResponse) => {
        return json.count;
    });
};
